import ApiService from "../ApiService";
const user = JSON.parse(localStorage.getItem("user"));

export default class TenantService {
  static getData = async (params) => {
    let cursor, property, keyword, propertyid;
    if (params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (user?.operational?.level === 1 && user?.type === "staff") {
      property = `&property_id=${user.operational.id}`;
    }
    if (params.property && params.property !== "") {
      propertyid = `&property_id=${params.property}`;
    }
    // console.log(params);
    // console.log("|||||||");
    const instance = await ApiService();
    return instance.get(
      `/tenant?num=${params.num || 1000}${cursor || ""}${property || ""}${
        propertyid || ""
      }${keyword || ""}`
    );
  };

  static getByID = async (id) => {
    const instance = await ApiService();
    return instance.get(`/tenant/${id}`);
  };

  static storeData = async (value) => {
    const instance = await ApiService();
    let params = {
      name: value.name,
      // category: {
      //   id: value.category,
      // },
      tenant_type: {
        id: parseInt(value.tenant_type),
      },
      floor: value.floor,
      email: value.email,
      logo: value.logo,
      service_charge_percentage: value.service_charge_percentage,
      tax_charge_percentage: value.tax_charge_percentage,
      bank_code: value.bank_code,
      bank_account_name: value.bank_account_name,
      bank_account_number: value.bank_account_number,
    };

    if (user?.operational?.level === 1 && user?.type === "staff") {
      params.property = {
        id: user.operational.id,
      };
    }
    // console.log(params);
    return instance.post(`/tenant`, params);
  };

  static putData = async (value) => {
    const instance = await ApiService();
    let params = {
      id: value.id,
      name: value.name,
      category: {
        id: value.category,
      },
      tenant_type: {
        id: parseInt(value.tenant_type),
      },
      floor: value.floor,

      email: value.email,
      logo: value.logo,

      service_charge_percentage: value.service_charge_percentage,
      tax_charge_percentage: value.tax_charge_percentage,
      bank_code: value.bank_code,
      bank_account_name: value.bank_account_name,
      bank_account_number: value.bank_account_number,
      open_st: value.open_st,
    };

    if (user?.operational?.level === 1 && user?.type === "staff") {
      params.property = {
        id: user.operational.id,
      };
    }

    return instance.put(`/tenant/${value.id}`, params);
  };

  static patchData = async (id, params) => {
    const instance = await ApiService();
    return instance.patch(`/tenant/${id}`, params);
  };

  static deleteData = async (params) => {
    const instance = await ApiService();
    return instance.delete(`/tenant/${params.id}`);
  };

  static getListOperationalHours = async (params) => {
    const instance = await ApiService();
    return instance.get(`/tenant/operational`);
  };

  static postOperationalHours = async (params) => {
    const instance = await ApiService();
    return instance.post(`/tenant/operational`, {
      items: params,
    });
  };
}
